import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/shared/components/ui/card';
import { KpiCard } from '@/shared/components/charts';
import { formatHours } from '@/shared/utils/formatHours';
import type { MyTimeAnalysisDto } from '../types';

interface MyTimeAnalysisKpiCardsProps {
  data: MyTimeAnalysisDto;
}

export function MyTimeAnalysisKpiCards({ data }: MyTimeAnalysisKpiCardsProps) {
  const { t } = useTranslation('personalSummary');

  return (
    <div
      className="grid grid-cols-2 gap-3 md:grid-cols-3"
      data-testid="personal-summary-time-kpi-cards"
    >
      <Card>
        <CardContent className="px-4 py-3">
          <p className="mb-1 text-xs font-medium text-muted-foreground">
            {t('timeAnalysis.kpi.estimated')}
          </p>
          <KpiCard
            value={data.totalEstimatedHours}
            displayValue={formatHours(data.totalEstimatedHours)}
          />
        </CardContent>
      </Card>

      <Card>
        <CardContent className="px-4 py-3">
          <p className="mb-1 text-xs font-medium text-muted-foreground">
            {t('timeAnalysis.kpi.tracked')}
          </p>
          <KpiCard
            value={data.totalTrackedHours}
            displayValue={formatHours(data.totalTrackedHours)}
            valueClassName="text-cyan-600 dark:text-cyan-400"
          />
        </CardContent>
      </Card>

      <Card className="col-span-2 md:col-span-1">
        <CardContent className="px-4 py-3">
          <p className="mb-1 text-xs font-medium text-muted-foreground">
            {t('timeAnalysis.kpi.efficiency')}
          </p>
          <KpiCard
            value={data.overallEfficiencyPercentage}
            displayValue={`${data.overallEfficiencyPercentage.toFixed(0)}%`}
            valueClassName="text-primary"
          />
        </CardContent>
      </Card>
    </div>
  );
}
